import { Box, CircularProgress } from "@mui/material";
import useGetCompanySuspensions from "../data-access/useGetCompanySuspensions";
import CompanySuspensionsAndObviations from "./ui/CompanySuspensions";

function ListOfSuspensions() {
  const { data, isLoading } = useGetCompanySuspensions();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        minWidth: "60vw",
        width: "80vw",
        mx: "auto",
      }}
    >
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <CompanySuspensionsAndObviations
            rows={data?.data?.companySuspensions}
            mode={"suspension"}
          />
          <CompanySuspensionsAndObviations
            rows={data?.data?.companyObviation}
            mode={"obviation"}
          />
        </>
      )}
    </Box>
  );
}

export default ListOfSuspensions;
